'use strict';

const OffersMap = require('./offers_map');

$(() => {
  const el = '.mpp-container .offers-map-container';

  if (!($(el).length > 0)) {
    return null;
  }

  const $desktopWrapper = $('.mpp-container .offers-map-desktop');
  const $mobileWrapper = $('.mpp-container .offers-map-mobile');
  const place = $('.mpp-container').data();
  return new OffersMap({
    el,
    $mobileWrapper: $mobileWrapper.length > 0 ? $mobileWrapper : undefined,
    $desktopWrapper: $desktopWrapper.length > 0 ? $desktopWrapper : undefined,
    place: {
      id: place.placeId,
      name: place.placeName,
      lat: place.placeLat,
      lon: place.placeLon,
      streetAddress: place.placeStreetAddress,
      category: {
        singular: place.placeCategorySingular,
      },
      recommendations: {
        total: place.placeRecommendationsTotal,
        percentage: place.placeRecommendationsPercentage,
      },
    },
    config: $(el).data('config'),
  });
});
